import { getAssessmentById } from '@/data/assessments'
import { AssessmentDetailPage } from './AssessmentDetailPage'

export function CybersecurityAssessment() {
  const assessment = getAssessmentById('cybersecurity')!
  return <AssessmentDetailPage assessment={assessment} />
}
